import { createPageEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { HelpCenterSettingsSupportWebsiteAppEntryPoint as main } from '@atlassian/jira-spa-apps-help-center-settings-support-website/entrypoint.tsx';
import { horizontalNavigationCsmSupportWebsiteEntryPoint } from '@atlassian/jira-horizontal-nav-csm-support-website/entrypoint.tsx';

export const HelpCenterSettingsSupportWebsiteEntryPoint = createPageEntryPoint({
	main,
	topNavigationMenuId: MENU_ID.HELP_CENTER_SETTINGS,
});

export const HelpCenterSettingsSupportWebsiteEntryPointWithHorizontalNavigation =
	createPageEntryPoint({
		main,
		topNavigationMenuId: MENU_ID.HELP_CENTER_SETTINGS,
		horizontalNavigation: horizontalNavigationCsmSupportWebsiteEntryPoint,
	});
